<form [formGroup]="formGroup">
    <nuc-checkbox [text]=text [formControl]="formControl" (dataChange)="setApplied($event)"></nuc-checkbox>
</form>
